import type {FC} from 'react';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props} from './types';

import * as S from './styles';

export const NoResultsView: FC<WithDomStyleProp<Props>> = ({
  buttonScheme,
  buttonText,
  color = 'text3',
  description,
  icon,
  iconColor = 'icon4',
  iconSize = 160,
  onButtonClick,
  text,
  ...rest
}) => (
  <S.Container {...rest}>
    {icon && <S.Icon color={iconColor} component={icon} iconSize={iconSize} />}
    <S.Text color={color}>{text}</S.Text>
    {description && <S.Description color={color}>{description}</S.Description>}
    {buttonText && (
      <S.Button onClick={onButtonClick} scheme={buttonScheme}>
        <S.ButtonText>{buttonText}</S.ButtonText>
      </S.Button>
    )}
  </S.Container>
);
